import t, { useState as p } from "react";
import i from "classnames";
import _ from "react-transition-group/CSSTransition";
import { mintelWhite as u, mintelGray500 as d } from "mintel-tokens";
import { u as T } from "./utils-C0l876fA.es.js";
import { u as v } from "./DarkModeProvider-xoZXm3ct.es.js";
import { T as k } from "./index-BB-Wk85r.es.js";
import { I as J } from "./Icon-ByeAHRM4.es.js";
import { L as x } from "./Link-D5gYj8AF.es.js";
import './JumpTo.css';const f = "JumpTo-module__spacing___UvBFQ", D = "JumpTo-module__jumpToPanel___gP0ri", A = "JumpTo-module__darkMode___SeGXY", E = "JumpTo-module__exitActive___-Df6v", N = "JumpTo-module__enterActive___orFr7", g = "JumpTo-module__enterDone___HSE9R", j = "JumpTo-module__exitDone___dYcFJ", h = "JumpTo-module__links___9ve9G", M = "JumpTo-module__header___udrLe", e = {
  spacing: f,
  jumpToPanel: D,
  darkMode: A,
  exitActive: E,
  enterActive: N,
  enterDone: g,
  exitDone: j,
  links: h,
  header: M
}, P = ({
  links: s,
  iconName: r = "open_tab"
}) => {
  const [o, c] = p(!1), { t: a } = T(), m = v();
  return (
    // Disable the eslint warnings about interactive elements because we're
    // only adding an onClick to stop interation
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    /* @__PURE__ */ t.createElement(
      "div",
      {
        onClick: (n) => {
          n.stopPropagation();
        },
        className: e.jumpTo
      },
      /* @__PURE__ */ t.createElement("div", { className: e.spacing }),
      /* @__PURE__ */ t.createElement(
        _,
        {
          in: o,
          timeout: 400,
          classNames: {
            // opening state
            enterActive: e.enterActive,
            // opened state
            enterDone: e.enterDone,
            // closing state
            exitActive: e.exitActive,
            // closed state
            exitDone: e.exitDone
          }
        },
        /* @__PURE__ */ t.createElement(
          "div",
          {
            className: i([
              e.jumpToPanel,
              m && e.darkMode
            ])
          },
          /* @__PURE__ */ t.createElement(
            "button",
            {
              type: "button",
              className: i(e.header, {
                [e.closedHeader]: !o
              }),
              onClick: () => {
                c(!o);
              },
              "aria-label": a(o ? "close jump to section" : "open jump to section"),
              tabIndex: 0,
              "aria-haspopup": "menu",
              "aria-owns": "links-list"
            },
            /* @__PURE__ */ t.createElement(k.Heading5, { responsive: !0 }, a("Jump to Section")),
            /* @__PURE__ */ t.createElement(
              J,
              {
                name: o ? "minus" : "open",
                size: 20,
                color: m ? u : d
              }
            )
          ),
          /* @__PURE__ */ t.createElement("div", { className: e.links, id: "links-list" }, s.map(({ label: n, onClick: l }) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            /* @__PURE__ */ t.createElement(x, { onClick: l, key: n, iconName: r }, n)
          )))
        )
      )
    )
  );
};
P.displayName = "JumpTo";
export {
  P as J
};
